
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 73 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"--darkreader-inline-fill":"#001446"},attrs:{"fill":"#001957","fill-rule":"evenodd","d":"M73 0H62.97l-9.89 14.975V0h-9.53l-.003 11.735h-6.77V3.803h-6.655l-.002 7.932h-6.816a8.221 8.221 0 00.82-3.59c0-4.496-3.957-8.14-8.386-8.145H0v30h9.506V7.67h1.895c1.996 0 3.613 1.642 3.613 3.668 0 2.023-1.618 3.659-3.611 3.662l6.017 15h10.11l-4.74-11.638h7.332v7.935h6.654v-7.935h6.774V30h9.53L73 0"}})])
          )
        }
      }
    